<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-summary-variable-statement-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
        <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="系統單號" width="97" align="left" fixed>
            <template slot-scope="scope">
                <span @click="$event => onClick($event, scope.row.sno)" style="font-size: 8.5pt;">{{ scope.row.uniqueNumber }}</span>
            </template>
        </el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.approvedVocherQty === 0 }">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="summary" label="摘要" min-width="300" class-name="strong" fixed show-overflow-tooltip />
        <el-table-column prop="iteM_NAM" label="支出/收入項目" min-width="120" class-name="strong" show-overflow-tooltip />
        <el-table-column label="出入帳日期" width="150">
            <template slot-scope="scope">
                <div>{{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="amount" label="支出/收入金額" class-name="blue strong" align="right" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.amount" :precision="scope.row.cny === 'TWD' ? null : 4" />
            </template>
        </el-table-column>
        <el-table-column prop="cny" label="幣別" min-width="70" align="center" />
        <el-table-column prop="rat" label="匯率" min-width="80" align="right" class-name="strong" />
        <el-table-column prop="amount" label="交易方式" min-width="110" align="right">
            <template slot-scope="scope"> {{ getPayWayText(scope.row.paY_WAY) }} </template>
        </el-table-column>
        <el-table-column prop="bankName" label="銀行帳戶" min-width="120" align="center">
            <template slot-scope="scope">
                <span>{{ scope.row.bankName || "--" }}</span>
            </template>
        </el-table-column>
        <el-table-column label="建立日期" width="120">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onClick(e, sno) {
            e.preventDefault();
            e.stopPropagation();
            this.$emit('openReceipt', sno);
        },
        onRowClick(data) {
            this.$emit('openDetail', data.sno, data.vocherStatus);
        },
        getPayWayText(type) {
            switch (type) {
            case 2:
                return '轉帳';
            default:
                return '--';
            }
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-variable-statement-table {
    .el-table__body-wrapper {
        height: 550px;
    }
    .blue {
        background-color: #f1f4ff;
    }
    .yellow {
        background-color: #fffde7;
    }
    .red {
        background-color: #fff5f5;
    }

    .el-table__row {
        cursor: pointer;
    }
}
</style>
